import {GetActiveMissionsResponse} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/coins/v1/service.types';

export const getOpenMissions = (): GetActiveMissionsResponse => {
  return {
    missions: [
      {
        reward: 100,
        missionType: {
          $case: 'addBirthdayMission',
          addBirthdayMission: {},
        },
      },
      {
        reward: 200,
        missionType: {
          $case: 'newsletterMission',
          newsletterMission: {},
        },
      },
    ],
    missionBanners: [
      {
        missionBanner: {
          $case: 'profileAndSecurityBanner',
          profileAndSecurityBanner: {
            title: 'Add your birthday - get rewarded twice',
            description: 'Bonus coins now and a gift on your day.',
          },
        },
      },
      {
        missionBanner: {
          $case: 'settingsPageBanner',
          settingsPageBanner: {
            title: 'Get your order updates, deals & more',
            description: 'Join our newsletter and claim bonus coins.',
          },
        },
      },
      {
        missionBanner: {
          $case: 'newsletterPageBannerText',
          newsletterPageBannerText: {
            title: 'Sign up & grab your reward instantly',
          },
        },
      },
    ],
  };
};
